<section class="users-section">
  <div id="customPopup" class="custom-popup">
    <div class="custom-popup-content">
      <button class="custom-popup-close" id="closeButton">
        <span>x</span>
      </button>
      <div class="popup-header">
        <h2 class="popup-title">Delete User</h2>
      </div>
      <hr class="popup-divider" />
      <p class="popup-message">Are you sure you want to delete the user?</p>
      <div class="popup-buttons">
        <button class="popup-container  small opened" id="deleteButton">Ok</button>
        <button class="popup-container  small opened"id="cancelButton">Cancel</button>
      </div>
    </div>
  </div>

  <div class="mid_container">
    <div class="mid_container_inner">
      <div class="comman_mid_wraper">
        <div class="admin_wraper">
          <div class="comman_box">
            <h3>Find User</h3>
            <ol class="ag-theme-material override-margin-user">
              <li>
                To filter by any column, hover on the column header, then click
                the Filter button.
              </li>
              <li>
                Type your filter value in the Filter field and hit Enter on your
                keyboard.
              </li>
              <li>
                To clear a filter, clear the value from the Filter field, and
                hit Enter on your keyboard again.
              </li>
            </ol>
            <div class="row">
              <div class="col-lg-6 col-sm-6 col-xs-6 override-width">
                <ag-grid-angular
                  [gridOptions]="gridOptions"
                  style="width: 105%; height: 600px"
                  (gridReady)="onGridReady($event)"
                  (filterModified)="onFilterModified($event)"
                  class="ag-theme-material"
                  [columnDefs]="columnDefs"
                  [context]="context"
                  [frameworkComponents]="frameworkComponents"
                >
                </ag-grid-angular>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-5 col-sm-5 col-xs-5">
      <a
        href="javascript:void(0)"
        (click)="navigateTiAdminHomePage()"
        class="btn btn-primary comman_btn override-spacing"
        >Go Back</a
      >
    </div>
  </div>

  <span
    id="reset_password_popup_link"
    data-toggle="modal"
    data-target="#myResetModal"
    class="hide-content"
  ></span>

  <div
    class="modal fade simulation_status_popup"
    id="myResetModal"
    role="dialog"
  >
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Reset Password</h4>
        </div>
        <div class="modal-body">
          <form
            class="form-horizontal reset_password_form"
            #userForm="ngForm"
            (ngSubmit)="resetPassword(userForm)"
            novalidate
          >
            <div class="form-group">
              <label class="control-label col-sm-3">Email</label>
              <div class="col-sm-8">
                <input
                  type="email"
                  required
                  class="form-control"
                  name="email"
                  [readonly]="true"
                  [(ngModel)]="user.email"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="control-label col-sm-3">Enter Password</label>
              <div class="col-sm-8">
                <input
                  type="password"
                  required
                  class="form-control"
                  name="newPassword"
                  [(ngModel)]="user.newPassword"
                  id="newPassword"
                />
                <img
                  class="reset_eye_img"
                  src="assets/images/eye_img.png"
                  id="newPassword_img"
                  (click)="revealPassword('newPassword', 'newPassword_img')"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="control-label col-sm-3">Confirm Password</label>
              <div class="col-sm-8">
                <input
                  type="password"
                  required
                  class="form-control"
                  name="confPassword"
                  [(ngModel)]="user.confPassword"
                  id="confPassword"
                />
                <img
                  class="reset_eye_img"
                  src="assets/images/eye_img.png"
                  id="confPassword_img"
                  (click)="revealPassword('confPassword', 'confPassword_img')"
                />
              </div>
            </div>
            <p class="pwd_hint">
              Your password cannot contain your email address, first name, or
              last name. It must be minimum of 8 characters in length,
              containing at least one upper case letter, one lower case letter,
              one number, and one special character.
            </p>
            <button
              type="submit"
              class="btn btn-primary comman_btn reset_password"
            >
              Submit
            </button>
            <button
              id="resetCancel"
              (click)="clearfields()"
              class="btn btn-primary comman_btn"
              data-dismiss="modal"
            >
              Cancel
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- <ngui-popup #popup></ngui-popup> -->
</section>